module.exports = __webpack_public_path__ + "img/box-title-1.f647847d.png";